import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { LogoImg } from "@/components/landing/Logo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-alabaster flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md rounded-[2rem] bg-white border border-line p-10 text-center shadow-[0_30px_60px_rgba(15,23,20,0.12)]"
        data-testid="payment-cancel-page"
      >
        <div className="flex justify-center mb-6">
          <LogoImg className="h-14 w-auto" />
        </div>
        <XCircle size={44} className="mx-auto text-terracotta" />
        <h1 className="mt-4 font-serif text-2xl font-semibold text-moss">Pagamento annullato</h1>
        <p className="mt-2 text-sm leading-relaxed text-sub">
          Nessun addebito è stato effettuato. I voucher ti aspettano quando vuoi.
        </p>
        <Link
          to="/#pacchetti"
          data-testid="cancel-back-pricing-link"
          className="mt-7 inline-block rounded-full bg-moss px-8 py-3.5 text-sm font-semibold text-alabaster transition-all duration-200 hover:bg-mosslight"
        >
          Torna ai pacchetti
        </Link>
      </motion.div>
    </div>
  );
}
